<Radio share={null} large={false} />

<script>
    import Radio from '/src/components/Radio.svelte'
</script>
